import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnChanges, OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from "@angular/forms";
import {IFcDropdownSelectOption} from "./fc-dropdown-select-option";
import {TypeUtils} from "../../../utils/type-utils";

@Component({
    selector: 'db-fc-dropdown-select',
    templateUrl: './fc-dropdown-select.component.html',
    styleUrls: ['./fc-dropdown-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FcDropdownSelectComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => FcDropdownSelectComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class FcDropdownSelectComponent implements OnInit, OnChanges, ControlValueAccessor, Validator {

  @Input() public value: any;
  @Input() public options: Array<IFcDropdownSelectOption>;
  @Input() public label: string;
  @Input() positionCLassName: string = "db-fc-dropdown-select__content_on_b";
  @Input() public trialFlow: boolean = false;
  @Input() public placeHolder?: string = '';
  @Output() public onOptionChoose = new EventEmitter<any>();

  public toggled: Boolean;
  public chosenOption: IFcDropdownSelectOption;

  public availableOptions: Array<IFcDropdownSelectOption> = [];
  public disabledOptions: Array<IFcDropdownSelectOption> = [];

  private _propagateChange: Function = (_: any) => {};

  constructor(
    private $element: ElementRef
  ) {
    this.toggled = false;
    this.chosenOption = null;
  }
  ngOnInit() {
    if (this.trialFlow) {
      this.options.map( option => {
        if (option.isAvailable) {
          this.availableOptions.push(option);
        } else {
          this.disabledOptions.push(option);
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.chosenOption = this.getOptionByValue(changes['value'].currentValue);
    }
  }

  private getOptionByValue(value: any): IFcDropdownSelectOption {
    return this.options.find((option) => option.value === value);
  }

  writeValue(value: any): void {
    this.chosenOption = this.getOptionByValue(value);
  }

  registerOnChange(fn: any): void {
    this._propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  validate(c: AbstractControl): ValidationErrors {
    return null;
  }

  registerOnValidatorChange(fn: () => void): void {}

  setDisabledState(isDisabled: boolean): void {}

  @HostListener('document:click', ['$event']) onDocumentClick($event: Event) {
    if (!this.$element.nativeElement.contains($event.target)) {
      this.toggleDropdown(false);
    }
  }

  public toggleDropdown(toggled?: Boolean) {
    if (TypeUtils.isUndefined(toggled)) {
      toggled = !this.toggled;
    }

    this.toggled = toggled;
  }

  public onOptionClick($event: Event, option: IFcDropdownSelectOption) {
    this.toggleDropdown(false);

    this.chosenOption = option;
    this._propagateChange(option.value);
    this.onOptionChoose.emit(option.value);
  }

}
